(function () {
  const ROOT_SELECTOR = '.ic-reelfy-looks';
  const mq = window.matchMedia('(max-width: 749.98px)');

  function hideArrows(root) {
    root.querySelectorAll('.flickity-prev-next-button').forEach((btn) => {
      btn.remove();
    });
  }

  function applyMobileSizing(root) {
    const carousel = root.querySelector('.rf-gallery-main.rf-carousel');
    if (!carousel) return;

    hideArrows(root);

    if (!mq.matches) return;

    const gap = 12;
    const width = Math.floor((carousel.clientWidth - gap * 2) / 3);
    if (width <= 0) return;

    carousel.querySelectorAll('.carousel-cell').forEach((cell) => {
      cell.style.setProperty('width', `${width}px`, 'important');
      cell.style.marginRight = `${gap}px`;
    });

    const FlickityCtor = window.Flickity;
    if (FlickityCtor && typeof FlickityCtor.data === 'function') {
      const instance = FlickityCtor.data(carousel);
      if (instance) {
        instance.options.prevNextButtons = false;
        instance.options.groupCells = false;
        instance.resize();
      }
    }
  }

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(applyMobileSizing);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', init);
  window.addEventListener('load', init);

  document.addEventListener('shopify:section:load', init);

  const observer = new MutationObserver(() => {
    init();
  });

  document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
    observer.observe(root, { childList: true, subtree: true });
  });
})();
